<div id="instrumentTypeForm">
    <span *ngIf="title && instrumentModel" class="text-3xl font-semibold">{{ title }} - {{instrumentModel.brand.name + ' - ' + instrumentModel.name }}</span>
    <div *ngIf="instrumentModel" class=" pb-0 m-0 overflow-auto">

        <form [formGroup]="instrumentModelForm" >

            <!-- First Row -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                <mat-form-field dense appearance="outline" class="flex items-center justify-center">
                    <mat-label>{{ 'NAME_LABEL' | translate }}</mat-label>
                    <input name="name" [formControl]="nameControl" matInput required>
                </mat-form-field>
                <!--                <mat-form-field dense appearance="outline" floatLabel="always" class="flex items-center justify-center">-->
                <!--                    <mat-label>Procedimiento</mat-label>-->
                <!--                    <input name="procedure" formControlName="procedure" matInput>-->
                <!--                </mat-form-field>-->

                <mat-form-field dense appearance="outline" floatLabel="always" class="flex items-center justify-center">
                    <mat-label>{{'INSTRUMENT.FAMILY' | translate}}</mat-label>
                    <input type="text" matInput [formControl]="familyControl" [matAutocomplete]="auto">
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                        <mat-option *ngFor="let option of filteredFamilies | async" [value]="option">
                            {{option.name}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex items-center justify-center">
                    <mat-label>{{'INSTRUMENT.BRAND' | translate}}</mat-label>
                    <input matInput type="text" [formControl]="brandControl" [matAutocomplete]="brandAuto" >
                    <mat-autocomplete #brandAuto="matAutocomplete" [displayWith]="displayBrandFn">
                        <mat-option *ngFor="let brand of filteredBrands | async" [value]="brand">
                            {{brand.name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </form>
        <div *ngIf="instrumentModel && (!instrumentModel.magnitudes || instrumentModel.magnitudes.length === 0)"
             class="text-xl text-gray-500 py-2 flex flex-row items-center gap-2 w-full">
            <span class="text-left">
              No existen magnitudes disponibles en este modelo de instrumento, desea copiar magnitudes y puntos basado en otro modelo.
            </span>
            <button class="ml-2 bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded transition-colors"
                    (click)="agregarMagnitudesDeOtroModelo(service)">Copiar de..</button>
        </div>

    </div>

    <!-- No Client Selected -->
    <div *ngIf="!instrumentModel">
        <span>Debe seleccionar un tipo de instrumento para modificar o presionar 'Nuevo' para crear un cliente nuevo</span>
    </div>
</div>


<div>
    <ng-container *ngIf="instrumentModel">
        <!-- Nuevo cabezal que reemplaza al expansion panel header -->
        <div class="flex items-center justify-between bg-gray-100 p-3 rounded-t-lg mb-4 mt-6">
            <div class="text-3xl font-medium leading-tight">
                Magnitudes
            </div>
            <button [matTooltip]="'Agregar Magnitud'" class="pr-2 bg-amber-500 hover:bg-amber-700 text-white rounded-lg text-xl transition flex items-center"
                    (click)="addMagnitude(instrumentModel, instrumentModel)">
                <mat-icon>add</mat-icon>
                Agregar Magnitud
            </button>
        </div>

        <!-- Contenido (antes dentro del expansion panel) -->
        <div class="p-6">
            <div *ngFor="let magnitud of getSortedMagnitudes()" class="flex flex-col  mb-8">
                <div class="flex flex-row justify-between items-center mb-4">
                    <div class="flex flex-row grow items-center gap-2">
                        <label class="justify-start text-2xl font-bold mr-1">Etiqueta:</label>
                        <input type="text" [(ngModel)]="magnitud.label" (blur)="onMagnitudLabelBlur(magnitud)" class="justify-start w-56 p-2 ring-1 ring-blue-400 rounded-md">
                        <h2 class="text-2xl ml-1 text-gray-800">{{' (' + magnitud.name + ')'}}</h2>

                        <label class="justify-start ml-16 text-2xl font-bold mr-1">Rango mínimo:</label>
                        <input type="text" [(ngModel)]="magnitud.minRange" (blur)="onMagnitudLabelBlur(magnitud)" class="justify-start w-16 p-2 ring-1 ring-blue-400 rounded-md">
                        <label class="justify-start ml-16 text-2xl font-bold mr-1">Rango máximo:</label>
                        <input type="text" [(ngModel)]="magnitud.maxRange" (blur)="onMagnitudLabelBlur(magnitud)" class="justify-start w-16 p-2 ring-1 ring-blue-400 rounded-md">
                    </div>
                    <div class="flex flex-row gap-2">
                        <button [matTooltip]="'Mover arriba'" 
                                class="bg-green-500 hover:bg-green-700 text-white rounded-lg text-xl transition flex items-center"
                                (click)="moveMagnitudeUp(magnitud)"
                                [disabled]="isFirstMagnitude(magnitud)">
                            <mat-icon>arrow_upward</mat-icon>
                        </button>
                        <button [matTooltip]="'Mover abajo'" 
                                class="bg-green-500 hover:bg-green-700 text-white rounded-lg text-xl transition flex items-center"
                                (click)="moveMagnitudeDown(magnitud)"
                                [disabled]="isLastMagnitude(magnitud)">
                            <mat-icon>arrow_downward</mat-icon>
                        </button>
                        <button [matTooltip]="'Borrar Magnitud'" class="bg-red-500 hover:bg-red-700 text-white rounded-lg text-xl transition flex items-center"
                                (click)="deleteMagnitude(magnitud)">
                            <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                        </button>
                        <button [matTooltip]="'Agregar punto'" class="bg-amber-500 hover:bg-amber-700 text-white rounded-lg text-xl transition flex items-center"
                                (click)="agregarPuntoMedida(magnitud)">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>
                <div class="overflow-x-auto bg-white shadow-md rounded-lg">
                    <table class="w-full border-collapse">
                        <!-- Encabezado -->
                        <thead class="bg-gray-100 text-gray-700">
                        <tr>
                            <th class="px-2 py-2 text-left border-b">Rango EBC</th>
                            <th class="px-2 py-2 text-left border-b">Unidad</th>
                            <th class="px-2 py-2 text-left border-b">Resolución</th>
                            <th class="px-2 py-2 text-left border-b">% Lectura</th>
                            <th class="px-2 py-2 text-left border-b">% FS</th>
                            <th class="px-2 py-2 text-left border-b">Dígitos</th>
                            <th class="px-2 py-2 text-left border-b">Patrón</th>
                            <th class="px-2 py-2 text-left border-b">Acciones</th>
                        </tr>
                        </thead>

                        <!-- Cuerpo de la tabla -->
                        <tbody class="divide-y divide-gray-200">

                        <tr *ngFor="let measurePoint of getSortedMeasurePoints(magnitud)" class="hover:bg-gray-50">
                            <!-- Campos de datos (se vuelven inputs si está en edición) -->
                            <td class="px-2 py-2">
                                <input *ngIf="isEditing(measurePoint)" [(ngModel)]="measurePoint.range"
                                       class="p-1 w-full border ring-1 rounded-md shadow-sm focus:outline-none focus:ring-2 ring-blue-500">
                                <span class="p-1 w-full" *ngIf="!isEditing(measurePoint)">{{ formatearConPrecision(measurePoint.range, measurePoint.resolution) }}</span>
                            </td>
                            <td class="px-2 py-2">
                                <select *ngIf="isEditing(measurePoint)" matTooltip="Unidad de medida"
                                        [(ngModel)]="measurePoint.unit"
                                        [compareWith]="compareUnits"
                                        class="bg-white text-gray-800 px-0.5 py-0.5 mx-0.5 rounded-lg ring-1 ring-gray-500 focus:ring-2 focus:ring-blue-500">
                                    <option *ngFor="let unit of unitsService.getUnitsByMagnitude(magnitud.name);"
                                            [ngValue]="unit">
                                        {{ unit }}
                                    </option>
                                </select>
                                <!--                                <input *ngIf="isEditing(measurePoint)" [(ngModel)]="measurePoint.unit"-->
                                <!--                                       class="p-1 w-full border ring-1 rounded-md shadow-sm focus:outline-none focus:ring-2 ring-blue-500">-->
                                <span class="p-1 w-full" *ngIf="!isEditing(measurePoint)">{{ measurePoint.unit }}</span>
                            </td>
                            <td class="px-2 py-2">
                                <input *ngIf="isEditing(measurePoint)" [(ngModel)]="measurePoint.resolution"
                                       class="p-1 w-full border ring-1 rounded-md shadow-sm focus:outline-none focus:ring-2 ring-blue-500">
                                <span class="p-1 w-full" *ngIf="!isEditing(measurePoint)">{{ measurePoint.resolution }}</span>
                            </td>
                            <td class="px-2 py-2">
                                <input *ngIf="isEditing(measurePoint)" [(ngModel)]="measurePoint.percentageOfReading"
                                       class="p-1 w-full border ring-1 rounded-md shadow-sm focus:outline-none focus:ring-2 ring-blue-500">
                                <span class="p-1 w-full" *ngIf="!isEditing(measurePoint)">{{ measurePoint.percentageOfReading }}</span>
                            </td>
                            <td class="px-2 py-2">
                                <input *ngIf="isEditing(measurePoint)" [(ngModel)]="measurePoint.percentageOfFullScale"
                                       class="p-1 w-full border ring-1 rounded-md shadow-sm focus:outline-none focus:ring-2 ring-blue-500">
                                <span class="p-1 w-full" *ngIf="!isEditing(measurePoint)">{{ measurePoint.percentageOfFullScale }}</span>
                            </td>
                            <td class="px-2 py-2">
                                <input *ngIf="isEditing(measurePoint)" [(ngModel)]="measurePoint.digits"
                                       class="p-1 w-full border ring-1 rounded-md shadow-sm focus:outline-none focus:ring-2 ring-blue-500">
                                <span class="p-1 w-full" *ngIf="!isEditing(measurePoint)">{{ measurePoint.digits }}</span>
                            </td>
                            <td class="px-2 py-2">
                                <select *ngIf="isEditing(measurePoint)" [(ngModel)]="measurePoint.standard" [compareWith]="_systemService.compareFunction"
                                        class="p-1 w-full border ring-1 rounded-md shadow-sm focus:outline-none focus:ring-2 ring-blue-500">
                                    <option *ngFor="let standardValue of _instrumentService.getAllStandardsByModel(magnitud.name)"
                                            [ngValue]="standardValue">{{ standardValue.indexName }}</option>
                                </select>
                                <span class="p-1 w-full" *ngIf="!isEditing(measurePoint)">{{ measurePoint.standard?.indexName }}</span>
                            </td>

                            <!-- Acciones: Alterna entre Editar/Borrar y Aceptar/Cancelar -->
                            <td class="px-2 py-2">
                                <div class="flex flex-row w-16" *ngIf="!isEditing(measurePoint)">
                                    <button matTooltip="Modificar punto de medida" class="bg-blue-500 hover:bg-blue-700 text-white rounded-lg text-sm p-1 mr-1 transition flex items-center justify-center"
                                            (click)="editarFila(measurePoint)">
                                        <mat-icon svgIcon="heroicons_outline:pencil"></mat-icon>
                                    </button>
                                    <button matTooltip="Duplica punto de medida" class="bg-amber-500 hover:bg-amber-700 text-white rounded-lg text-sm p-1 mr-1 transition flex items-center justify-center"
                                            (click)="duplicarFila(measurePoint, magnitud)">
                                        <mat-icon svgIcon="heroicons_outline:duplicate"></mat-icon>
                                    </button>
                                    <button matTooltip="Borrar punto de medida" class="bg-red-500 hover:bg-amber-700 text-white rounded-lg text-sm p-1 transition flex items-center justify-center"
                                            (click)="borrarFila(measurePoint, magnitud)">
                                        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                                    </button>
                                </div>

                                <div class="flex flex-row w-16" *ngIf="isEditing(measurePoint)">
                                    <button class="bg-green-500 hover:bg-green-700 text-white rounded-lg text-sm p-1 mr-1 transition flex items-center justify-center"
                                            (click)="aceptarEdicion(measurePoint, magnitud)">
                                        <mat-icon svgIcon="heroicons_outline:check"></mat-icon>
                                    </button>
                                    <button class="bg-gray-500 hover:bg-gray-700 text-white rounded-lg text-sm p-1 transition flex items-center justify-center"
                                            (click)="cancelarEdicion(measurePoint,magnitud)">
                                        <mat-icon svgIcon="heroicons_outline:x"></mat-icon>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <!-- Botón para agregar nuevo punto de medida -->

                </div>
            </div>
        </div>
    </ng-container>
</div>